import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {UserFiltersType} from '../../interfaces/user'

const initialUserFilter: UserFiltersType = {
  search: '',
  page: 1,
  pageSize: 10,
  timestamp: '',
}

const userFilterSlice = createSlice({
  name: 'userFilter',
  initialState: initialUserFilter,
  reducers: {
    setUserFilter: (state, action: PayloadAction<UserFiltersType>) => {
      state.search = action.payload.search
      state.page = action.payload.page
      state.pageSize = action.payload.pageSize
    },
    reseUserFilter: (state) => {
      return {
        ...initialUserFilter,
        timestamp: new Date().getUTCMilliseconds().toString(),
      }
    },
  },
})

export const {setUserFilter, reseUserFilter} = userFilterSlice.actions

export default userFilterSlice.reducer
